import React, { useEffect, useRef, useState } from 'react'
import { SeccionVideos } from '../components/seccion_videos'
import { ImageOutlined } from '@mui/icons-material'
import UpgradePublication from '../components/global/UpgradePublication';
import { ProfileContent, useProovedorData, returnCurrentDateTime } from '../components'
import CallApi from '../data/CallApi';
import PublicationCard from './Hosming/PublicationCard';
import PreviewPublication from './Hosming/PreviewPublication';
import { LoadingPublications } from '../components/skeleton/LoadingPublications';
import { throttle } from "lodash";
import { toast } from 'react-toastify';
import { Preloader } from '../components/Preloader';
import { useLocation, useParams } from 'react-router-dom';

export const GlobalPublications = ({ where = 'main', keyBranch }) => {
    const current_path = useParams();
    const { nit } = useParams();

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const companyNIT = queryParams.get("search");
    const userAuth = queryParams.get("authCode");
    const postParam = queryParams.get("post");

    const key = userAuth ? userAuth : (companyNIT ? companyNIT : (keyBranch ?? "no_detected"));

    const { data_user, loadImageS, dbData, token_local, setShowLogin } = useProovedorData() ?? [];

    const [isLoading, setIsLoading] = useState({
        publication: false,
        morePublication: false,
        oldPublication: false
    });

    const refObjectPag = useRef({ page: 1, request_dt: null, number_results: 0, currentList: [] });
    const refUL = useRef(false);
    const refState = useRef(false);

    const urlsGet = {
        'main': 'api/publications',
        'user': 'api/publications?userKey=me',
        'oUser': 'api/publications?userKey=' + key,
        'branch': 'api/publications?branchKey=' + key,
        'company': 'api/publications?company=' + key
    };

    const returnUrlPost = (searchCode = '', its_me = false) => {
        let newURL = '';
        const path = current_path?.['*'];

        if (keyBranch) newURL = '/administrar/empresa/publicaciones/' + nit;
        if (companyNIT) newURL = '/company/publications?search=' + companyNIT;
        if (userAuth) newURL = '/user/posts?authCode=' + userAuth;
        if (path == '') newURL = (String(searchCode).length == 45 ? (its_me ? "/user/posts" : `/user/posts?authCode=${searchCode}`) : `/company/publications?search=${searchCode}`);

        return path == 'user/posts' && !userAuth ? path : newURL;
    }

    const returnUrlRequest = userAuth && current_path?.['*'] == 'user/posts' ? `api/users/${userAuth}/publications` : (nit ?
        `api/companys/${keyBranch}/publications` : 'api/publications'
    );

    const whereKey = where + (key != '' ? `_${key}` : '');

    const [listPublications, setListPublications] = useState([]);
    const [viewPublication, setViewPublication] = useState({});
    const [modalUpState, setModalUpState] = useState(false);

    const myProfile = <ProfileContent profile_url={data_user ? data_user?.perfil : null} loadImageS={loadImageS} style={{ height: '100%' }} />;

    // const { page, request_dt, number_results } = refObjectPag.current;

    async function getPublication(cacheBool = false) {
        const paramDetected = String(postParam).length == 45 ? true : false;

        if (!dbData) return console.error("No fue posible cargar los datos locales");
        const { page, request_dt, number_results, currentList } = refObjectPag.current;

        const currentLength = currentList?.length;
        const currentLoad = currentLength == 0 ? 'publication' : 'morePublication';
        if (refState.current == true) return;

        setIsLoading((current_val) => ({
            ...current_val,
            [currentLoad]: true
        }));
        refState.current = true;

        try {
            let postExp = await dbData.get('expiration', whereKey); //publication Expiration
            let currentDT = returnCurrentDateTime(); //current date time
            let updatePosts = false;

            if (postExp) {
                const expirationDT = new Date(postExp.Value);
                const newCurrentDT = new Date(currentDT);

                expirationDT.setMinutes(expirationDT.getMinutes() + 10);

                if (newCurrentDT > expirationDT) updatePosts = true;
            } else {
                updatePosts = true;
            }

            const cachePublication = await dbData.get('posts', whereKey);
            const lengthCachePost = (cachePublication?.Value ?? []).length;

            var fullList = [];

            if ((updatePosts || !cachePublication) && cacheBool) {
                const fetchPublication = await CallApi({ url: urlsGet[where] });

                if (fetchPublication) {
                    fullList = fetchPublication.result;

                    refObjectPag.current = {
                        page: (fetchPublication?.current_page ?? 1) + 1,
                        request_dt: fetchPublication?.request_dt,
                        number_results: fetchPublication?.data_count ?? 0,
                        currentList: fullList
                    };
                } else {
                    fullList = cachePublication?.Value;
                }

                if ((fetchPublication?.result).length > 0) await dbData.put('expiration', { id: whereKey, Value: currentDT });
                await dbData.put('posts', { id: whereKey, Value: fullList });
            } else {
                const getNew = (currentLength + 10) <= lengthCachePost ? false : true;

                if (getNew && !cacheBool) {
                    const lastPost_dt = cachePublication.Value[lengthCachePost - 1];
                    const valRequest_dt = request_dt ?? lastPost_dt.published_at;

                    if (request_dt == null || (number_results == 10)) {
                        const fetchPublication = await CallApi({
                            url: urlsGet[where] + (where == 'main' ? '?' : '&') + `page=${page}&request_dt=${valRequest_dt}`
                        });

                        const reloadList = [...currentList];
                        fullList = reloadList.concat(fetchPublication?.result);

                        refObjectPag.current = {
                            page: (fetchPublication?.current_page ?? 1) + 1,
                            request_dt: fetchPublication?.request_dt,
                            number_results: fetchPublication?.data_count ?? 0,
                            currentList: fullList
                        };

                        await dbData.put('posts', { id: whereKey, Value: fullList });
                        if (postExp) {
                            const newExpirationDT = new Date(postExp.Value);
                            newExpirationDT.setMinutes(newExpirationDT.getMinutes() + 1);

                            const pad = n => n.toString().padStart(2, '0');
                            const newIso = (
                                newExpirationDT.getFullYear() +
                                '-' + pad(newExpirationDT.getMonth() + 1) +
                                '-' + pad(newExpirationDT.getDate()) +
                                'T' + pad(newExpirationDT.getHours()) +
                                ':' + pad(newExpirationDT.getMinutes()) +
                                ':' + pad(newExpirationDT.getSeconds())
                            );

                            await dbData.put('expiration', { id: whereKey, Value: newIso });
                        } else {
                            await dbData.put('expiration', { id: whereKey, Value: currentDT });
                        }
                    } else {
                        toast.info("Fin de publicaciones...");
                    }
                } else {
                    fullList = (cachePublication?.Value ?? []).slice(0, currentLength + 10);
                    refObjectPag.current.currentList = fullList;
                }
            }
            if (fullList.length > currentLength) {
                setListPublications(fullList);
            }
        } catch (error) {
            console.error("Error aqui:", error);
        } finally {
            setIsLoading((current_val) => ({
                ...current_val,
                [currentLoad]: false
            }));
            refState.current = false;
        }
    }

    async function increaseComment() {
        const authCode_Post = viewPublication?.authCode;

        setListPublications((current_list) => {
            let tempList = [...current_list];

            tempList = tempList.map((obj) => {
                if (obj?.authCode == authCode_Post) obj.comment_count = parseInt(obj?.comment_count) + 1;
                return obj;
            });

            return tempList;
        });

        const cachePost = await dbData.get('posts', whereKey);
        const postUpgrated = (cachePost.Value ?? []).map((obj) => {
            if (obj?.authCode == authCode_Post) obj.comment_count = parseInt(obj?.comment_count) + 1;
            return obj;
        });

        await dbData.put('posts', { id: whereKey, Value: postUpgrated });
    }

    useEffect(() => { getPublication(true) }, [data_user]);

    useEffect(() => {
        const getHomewView = document.getElementById("main-page");

        if (dbData) {
            getPublication(true);
            if (getHomewView) getHomewView.addEventListener('scroll', handleScroll);
        }

        return () => {
            if (getHomewView) getHomewView.removeEventListener('scroll', handleScroll);
        };
    }, [dbData]);

    const handleScroll = throttle(() => {
        const getHomewView = document.getElementById("main-page");
        if (!getHomewView) return console.error("No puedes ingresar sin obtener el elemento main");

        const { scrollTop, clientHeight, scrollHeight } = getHomewView;


        if ((scrollTop + clientHeight >= scrollHeight - 10) && refState.current == false && dbData) getPublication();
    }, 500);

    return (
        <>
            <SeccionVideos />
            {
                current_path?.['*'] != 'company/publications' && (
                    <>
                        <div className='new-post-content shadow-lvl2'>
                            {myProfile}

                            <button type='button' className='default-buttons' onClick={() => token_local.length < 90 ? setShowLogin(true) : setModalUpState(true)}>
                                Compartenos
                                <ImageOutlined style={{ color: '#0B8800', fontSize: '28px' }} />
                            </button>
                        </div>

                        <UpgradePublication
                            myProfile={myProfile}
                            setModalState={setModalUpState}
                            modalState={modalUpState}
                            myName={data_user?.fullname}
                            urlRequest={returnUrlRequest}
                        />
                    </>
                )
            }


            <ul ref={refUL} className='content-colum' key={where + key} style={{ gap: '2rem', paddingBottom: '2rem' }}>
                {
                    !isLoading.publication ? (
                        (listPublications ?? []).length > 0 && listPublications.map((post, index) => (
                            <PublicationCard
                                data={post}
                                index={index}
                                loadImageS={loadImageS}
                                selectPost={setViewPublication}
                                getUrlPost={returnUrlPost}
                            />
                        ))
                    ) : (
                        <LoadingPublications />
                    )
                }
            </ul>

            <PreviewPublication
                publicationSelected={viewPublication}
                myProfile={data_user?.perfil}
                myFullName={data_user?.fullname}
                removeProduct={setViewPublication}
                loadImageS={loadImageS}
                dbData={dbData}
                getUrlPost={returnUrlPost}
                increaseComment={increaseComment}
            />

            {
                isLoading.morePublication && (
                    <Preloader colorSelected='var(--empresa-color)' />
                )
            }
        </>
    )
}
//    const newPromesa = new Promise((resolve) => {
//         setTimeout(() => {
//             console.log("cargando delay...");
//             resolve();
//         }, 5000);
//     });

//     await newPromesa.then(() => console.log("Promesa resuelta!"));